import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

// every component inside your app can access the shared state via useApp()
import { AppProvider } from './context/AppContext';

const root = createRoot(document.getElementById('root'));
root.render(
    <AppProvider>
      <App />
    </AppProvider>
);

// MeR 260422 AppProvider
// MeR 250107 React 19.0.0